export class ApiError extends Error {
  status: number
  code: string

  constructor(status: number, code: string) {
    super(code)
    this.status = status
    this.code = code
  }
}

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...(options?.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options?.headers,
    },
  })

  if (!response.ok) {
    let code = `http_${response.status}`
    try {
      const body = await response.json() as { error?: string }
      if (body.error) code = body.error
    } catch {
      // A non-JSON error still has a useful status code.
    }
    throw new ApiError(response.status, code)
  }

  if (response.status === 204) return undefined as T
  return response.json() as Promise<T>
}

export async function uploadImage(file: File): Promise<{ url: string }> {
  const body = new FormData()
  body.append('image', file)
  return api<{ url: string }>('/api/images', { method: 'POST', body })
}
